import { IS_LOCAL_ENV } from "@/data/constants";

export const KAMELEOON = {
  SITE_CODE: 'iw31avyafw',
  USER_AGENT_BOT: "curl/8.0",
  CUSTOM_DATA: {
    SP_APP_ID: 'sp_app_id',
    SP_DOMAIN_USERID: 'sp_domain_userid',
    SP_DOMAIN_SESSIONID: 'sp_domain_sessionid',
    SP_ID_CROSS_DEVICE: "Snowplow_id-cross-device",
    SP_CUSTOM_CONTEXT: "sp_custom_context_1",
  },
};

export const VISITOR_CODE_COOKIE_NAME = 'kameleoonVisitorCode';

export enum KameleoonDomains {
  Development = 'local.design-system.ca',
  Staging = 'uat-shop.shoppersdrugmart.ca',
  Production = '.shoppersdrugmart.ca',
  Lowers = '*.lblw.cloud',
}

export enum KameleoonEnvironment {
  Production = "production",
  Staging = "staging",
  Development = "development",
  Lowers = "lowers"
}

export enum KamErrors {
  Init = 'initialize',
  WarehouseKey = 'getWarehouseKey',
}

export const KAMELEOON_FEATURE_FLAGS = {
  ENABLE_SEARCH_TYPEAHEAD: IS_LOCAL_ENV ? 'enable_search_typeahead' : 'enable_m6_search_typeahead',
  SNOWPLOW_PERFECT_EXPERIENCE_FLAG: 'enable_snowplow_perfect_experience',
  ENABLE_SRP_FEEDBACK: 'sdm-web-srp-relevance-feedback',
};
